import React, { useEffect, useState } from 'react';
import { IonHeader, IonTitle, IonToolbar, IonIcon, IonGrid, IonRow, IonCol, IonToast, IonicSafeString } from '@ionic/react';
import './AppHeader.scss';
import { closeCircle, chevronBack, menu } from 'ionicons/icons';
import { ApplicationState } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import '../theme/common.scss';
import * as headerFooterStore from '../store/HeaderFooterStore';
import { bindActionCreators } from 'redux'
import MopHeaderMenusModal from '../modals/MopHeaderMenusModal'

interface LocationListenerProps {
    contentRef: React.RefObject<HTMLIonContentElement>
}

const LocationListener: React.FC<LocationListenerProps> = (props) => {

    const location = useLocation();
    const basketState = useSelector((state: ApplicationState) => state.basket);

    // Set up a listener to notify the HeaderFooter store when the page changes

    useEffect(() => {
        if(props.contentRef.current != null && location.pathname != undefined){
            if(location.pathname.includes('/menuitem') && !props.contentRef.current.classList.contains("negative-margin")){
                props.contentRef.current.classList.add("negative-margin");
            }else{
                props.contentRef.current.classList.remove("negative-margin");
            }
        }
    }, [location.pathname]);

    const toastMessage: IonicSafeString = new IonicSafeString('<div style="display: flex; justify-content: center; white-space: nowrap;"><svg style="margin-right: 10px" width="18" height="18" fill="white" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path fill - rule="evenodd" clip - rule="evenodd" d = "M8.99999 0.666626C4.39999 0.666626 0.666656 4.39996 0.666656 8.99996C0.666656 13.6 4.39999 17.3333 8.99999 17.3333C13.6 17.3333 17.3333 13.6 17.3333 8.99996C17.3333 4.39996 13.6 0.666626 8.99999 0.666626ZM8.99999 15.6666C5.32499 15.6666 2.33332 12.675 2.33332 8.99996C2.33332 5.32496 5.32499 2.33329 8.99999 2.33329C12.675 2.33329 15.6667 5.32496 15.6667 8.99996C15.6667 12.675 12.675 15.6666 8.99999 15.6666ZM7.33332 10.8083L12.2333 5.90829C12.5583 5.58329 13.0917 5.58329 13.4167 5.90829C13.7417 6.23329 13.7417 6.75829 13.4167 7.08329L7.92499 12.575C7.59999 12.9 7.07499 12.9 6.74999 12.575L4.59166 10.4166C4.26666 10.0916 4.26666 9.56663 4.59166 9.24163C4.74735 9.08558 4.95873 8.99789 5.17916 8.99789C5.39959 8.99789 5.61096 9.08558 5.76666 9.24163L7.33332 10.8083Z" /></svg> <span>Added to Order</span></div>');

    return (
        <IonToast
            animated={true}
            duration={2000}
            isOpen={basketState && (location.pathname.includes("/categoriesb") || location.pathname.includes("/menuitem") || location.pathname.includes('/deals')) ? basketState?.toastNotificationOpen : false}
            position={"bottom"}
            cssClass={"toastStyle"}
            message={toastMessage}
            color="success"
        />
    );
};

export default LocationListener;
